import { getDatabricksDashboardLink } from '~/lib/databricks/getDatabricksDashboardLink';
import type { DashboardEmbedConfig } from '~/lib/databricks/types';

export async function getMarketingCampaignsDashboardLink(
  campaignId?: string,
): Promise<DashboardEmbedConfig | null> {
  const baseUrl = '/api/mixone/api/v1/dashboards/digital_campaign_planner/link';

  const apiUrl = campaignId
    ? `${baseUrl}?dashboard_type=campaign&entity_id=${campaignId}`
    : `${baseUrl}?dashboard_type=general_marketing`;

  return getDatabricksDashboardLink(apiUrl);
}
